<template>
  <div class="mc-delivery-track-sidebar-detail-item mc-delivery-track-sidebar-detail-item--edit">
    <div class="mc-delivery-track-sidebar-edit-alert">
      <McAlert
        class="mb-2"
        variant="info"
        text="Rentang waktu perjalanan akan diperbarui mengikuti perubahan ini"
        withIcon
        :withGap="false"
        iconPosition="center"
      />
    </div>

    <div class="mc-delivery-track-sidebar-edit-fields">
      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.geofenceIn"
          label="Masuk Geolokasi"
          name="geofenceIn"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isGeofenceInRequired ? '|required' : ''}|geofenceInGtStartTime|geofenceInMax24hEarlier|geofenceInNotEqualActualPick|geofenceInLteActualPick|geofenceInNotEqualGeofenceOut|geofenceInLteGeofenceOut`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            geofenceInGtStartTime,
            geofenceInMax24hEarlier,
            geofenceInNotEqualActualPick,
            geofenceInLteActualPick,
            geofenceInNotEqualGeofenceOut,
            geofenceInLteGeofenceOut,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            geofenceInGtStartTime: `Tidak boleh sebelum atau sama dengan penugasan dijalankan: ${assignmentStartTimeFormatted}`,
            geofenceInMax24hEarlier: 'Tidak boleh melebihi 24 jam lebih awal',
            geofenceInNotEqualActualPick: 'Tidak boleh sama dengan waktu aktual diambil',
            geofenceInLteActualPick: 'Tidak boleh melebihi waktu aktual diambil',
            geofenceInNotEqualGeofenceOut: 'Tidak boleh sama dengan waktu keluar geolokasi',
            geofenceInLteGeofenceOut: 'Tidak boleh melebihi waktu keluar geolokasi',
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
      </div>

      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.actualPick"
          label="Aktual Diambil"
          name="actualPick"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isActualPickRequired ? '|required' : ''}|actualPickGtStartTime|actualPickGtGeofenceIn|actualPickLtGeofenceOut|actualPickLtGeofenceInDrop|actualPickLtActualDrop`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            actualPickGtStartTime,
            actualPickGtGeofenceIn,
            actualPickLtGeofenceOut,
            actualPickLtGeofenceInDrop,
            actualPickLtActualDrop,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            actualPickGtStartTime: `Tidak boleh sebelum atau sama dengan penugasan dijalankan: ${assignmentStartTimeFormatted}`,
            actualPickGtGeofenceIn: 'Tidak boleh kurang dari atau sama dengan waktu masuk geolokasi',
            actualPickLtGeofenceOut: 'Tidak boleh lebih dari atau sama dengan waktu keluar geolokasi',
            actualPickLtGeofenceInDrop: 'Tidak boleh lebih dari atau sama dengan waktu masuk geolokasi kirim',
            actualPickLtActualDrop: 'Tidak boleh lebih dari atau sama dengan waktu aktual terkirim',
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
        <p v-if="actualPickTarget" class="mc-delivery-track-sidebar-edit-field-note">
          {{ `(Target: ${actualPickTarget})` }}
        </p>
      </div>

      <div class="mc-delivery-track-sidebar-edit-field">
        <FormulateInput
          outer-class="mb-0 w-100"
          v-model="form.geofenceOut"
          label="Keluar Geolokasi"
          name="geofenceOut"
          type="date-picker"
          datepickerType="datetime"
          value-type="YYYY-MM-DDTHH:mm:ss.SSSZ"
          format="DD MMM YYYY HH:mm"
          append-to-body
          :validation="`bail${isGeofenceOutRequired ? '|required' : ''}|geofenceOutGtActualPick|geofenceOutLtGeofenceInDrop|geofenceOutLtActualDrop`"
          validation-behavior="live"
          error-behavior="live"
          :validation-rules="{
            geofenceOutGtActualPick,
            geofenceOutLtGeofenceInDrop,
            geofenceOutLtActualDrop,
          }"
          :validation-messages="{
            required: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
            geofenceOutGtActualPick: 'Tidak boleh kurang dari atau sama dengan waktu aktual diambil',
            geofenceOutLtGeofenceInDrop: 'Tidak boleh lebih dari atau sama dengan waktu masuk geolokasi kirim',
            geofenceOutLtActualDrop: 'Tidak boleh lebih dari atau sama dengan waktu aktual terkirim',
          }"
          :showSecond="false"
          :confirm="true"
          confirmText="Terapkan"
        />
      </div>
    </div>
  </div>
</template>

<script>
import McAlert from '@/components/McAlert'
import moment from 'moment'

export default {
  components: {
    McAlert,
  },
  props: {
    geofenceIn: {
      type: String,
      default: '',
    },
    actualPick: {
      type: String,
      default: '',
    },
    actualPickTarget: {
      type: String,
      default: '',
    },
    geofenceOut: {
      type: String,
      default: '',
    },
    actualDrop: {
      type: String,
      default: '',
    },
    geofenceInDrop: {
      type: String,
      default: '',
    },
    geofenceOutDrop: {
      type: String,
      default: '',
    },
    delivery: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        geofenceIn: this.normalizeDateValue(this.geofenceIn),
        actualPick: this.normalizeDateValue(this.actualPick),
        geofenceOut: this.normalizeDateValue(this.geofenceOut),
      },
    }
  },
  computed: {
    assignmentStartTime() {
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'

      if (isTransit) {
        const originId = this.delivery?.origin_address?.id
        const transit = this.delivery?.transits?.find((t) => t.origin_address?.id === originId)
        return transit?.fleet_task?.actual_departure_on || null
      }

      return this.delivery?.fleet_task?.actual_departure_on || null
    },
    assignmentStartTimeFormatted() {
      if (!this.assignmentStartTime) return ''
      return moment(this.assignmentStartTime).locale('id').format('DD MMM YYYY, HH:mm')
    },
    assignmentEndTime() {
      const isTransit = this.delivery?.shipment_type === 'TRANSIT'
      let arrivalOn = null

      if (isTransit) {
        const originId = this.delivery?.origin_address?.id
        const transit = this.delivery?.transits?.find((t) => t.origin_address?.id === originId)
        arrivalOn = transit?.fleet_task?.actual_arrival_on
      } else {
        arrivalOn = this.delivery?.fleet_task?.actual_arrival_on
      }

      return arrivalOn || moment().toISOString()
    },
    assignmentEndTimeFormatted() {
      if (!this.assignmentEndTime) return ''
      return moment(this.assignmentEndTime).locale('id').format('DD MMM YYYY, HH:mm')
    },
    isGeofenceInRequired() {
      return !!this.normalizeDateValue(this.geofenceIn)
    },
    isActualPickRequired() {
      return !!this.normalizeDateValue(this.actualPick)
    },
    isGeofenceOutRequired() {
      return !!this.normalizeDateValue(this.geofenceOut)
    },
  },
  watch: {
    geofenceIn(newVal) {
      this.form.geofenceIn = this.normalizeDateValue(newVal)
      console.log(this.form.geofenceIn)
    },
    actualPick(newVal) {
      this.form.actualPick = this.normalizeDateValue(newVal)
    },
    geofenceOut(newVal) {
      this.form.geofenceOut = this.normalizeDateValue(newVal)
    },
    form: {
      handler(newVal) {
        this.$emit('change', {
          geofenceIn: newVal.geofenceIn || '',
          actualPick: newVal.actualPick || '',
          geofenceOut: newVal.geofenceOut || '',
        })
        this.$emit('validation-change', this.getValidationResult())
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getValidationResult() {
      const checks = [
        {
          check: !this.isGeofenceInRequired || !!this.form.geofenceIn,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: !this.isActualPickRequired || !!this.form.actualPick,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: !this.isGeofenceOutRequired || !!this.form.geofenceOut,
          message: 'Tidak bisa dikosongkan karena sudah ada data sebelumnya',
        },
        {
          check: this.geofenceInGtStartTime({ value: this.form.geofenceIn }),
          message: `Tidak boleh sebelum atau sama dengan penugasan dijalankan: ${this.assignmentStartTimeFormatted}`,
        },
        {
          check: this.geofenceInMax24hEarlier({ value: this.form.geofenceIn }),
          message: 'Tidak boleh melebihi 24 jam lebih awal',
        },
        {
          check: this.geofenceInNotEqualActualPick({ value: this.form.geofenceIn }),
          message: 'Tidak boleh sama dengan waktu aktual diambil',
        },
        {
          check: this.geofenceInLteActualPick({ value: this.form.geofenceIn }),
          message: 'Tidak boleh melebihi waktu aktual diambil',
        },
        {
          check: this.geofenceInNotEqualGeofenceOut({ value: this.form.geofenceIn }),
          message: 'Tidak boleh sama dengan waktu keluar geolokasi',
        },
        {
          check: this.geofenceInLteGeofenceOut({ value: this.form.geofenceIn }),
          message: 'Tidak boleh melebihi waktu keluar geolokasi',
        },
        {
          check: this.actualPickGtStartTime({ value: this.form.actualPick }),
          message: `Tidak boleh sebelum atau sama dengan penugasan dijalankan: ${this.assignmentStartTimeFormatted}`,
        },
        {
          check: this.actualPickGtGeofenceIn({ value: this.form.actualPick }),
          message: 'Tidak boleh kurang dari atau sama dengan waktu masuk geolokasi',
        },
        {
          check: this.actualPickLtGeofenceOut({ value: this.form.actualPick }),
          message: 'Tidak boleh lebih dari atau sama dengan waktu keluar geolokasi',
        },
        {
          check: this.actualPickLtGeofenceInDrop({ value: this.form.actualPick }),
          message: 'Tidak boleh lebih dari atau sama dengan waktu masuk geolokasi kirim',
        },
        {
          check: this.actualPickLtActualDrop({ value: this.form.actualPick }),
          message: 'Tidak boleh lebih dari atau sama dengan waktu aktual terkirim',
        },
        {
          check: this.geofenceOutGtActualPick({ value: this.form.geofenceOut }),
          message: 'Tidak boleh kurang dari atau sama dengan waktu aktual diambil',
        },
        {
          check: this.geofenceOutLtGeofenceInDrop({ value: this.form.geofenceOut }),
          message: 'Tidak boleh lebih dari atau sama dengan waktu masuk geolokasi kirim',
        },
        {
          check: this.geofenceOutLtActualDrop({ value: this.form.geofenceOut }),
          message: 'Tidak boleh lebih dari atau sama dengan waktu aktual terkirim',
        },
      ]

      const firstFailedCheck = checks.find((item) => !item.check)
      if (firstFailedCheck) {
        return {
          isValid: false,
          message: firstFailedCheck.message,
        }
      }

      return {
        isValid: true,
        message: '',
      }
    },
    parseDateValue(value) {
      const normalized = this.normalizeDateValue(value)
      if (!normalized) return null

      const parsed = moment(normalized, 'YYYY-MM-DDTHH:mm:ss.SSSZ', true)
      return parsed.isValid() ? parsed : null
    },
    normalizeDateValue(value) {
      if (!value || value === '-') return ''

      const isoFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ'
      if (moment(value, isoFormat, true).isValid()) return value

      const sanitizedValue = String(value).replace(/\s+(WIB|WITA|WIT|UTC[+-]\d{1,2})$/i, '')

      const parsedId = moment(sanitizedValue, ['DD MMM YYYY, HH:mm', 'DD MMM YYYY HH:mm'], 'id', true)
      if (parsedId.isValid()) return parsedId.format(isoFormat)

      const parsedEn = moment(sanitizedValue, ['DD MMM YYYY, HH:mm', 'DD MMM YYYY HH:mm'], 'en', true)
      if (parsedEn.isValid()) return parsedEn.format(isoFormat)

      const parsedIso = moment(sanitizedValue, moment.ISO_8601, true)
      if (parsedIso.isValid()) return parsedIso.format(isoFormat)

      const fallbackParsed = moment(sanitizedValue)
      return fallbackParsed.isValid() ? fallbackParsed.format(isoFormat) : ''
    },
    geofenceInGtStartTime({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const startTime = this.assignmentStartTime ? moment(this.assignmentStartTime) : null

      if (!geofenceIn || !startTime) return true
      return geofenceIn.isAfter(startTime, 'second')
    },
    geofenceInMax24hEarlier({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const actualPick = this.parseDateValue(this.form.actualPick)

      if (!geofenceIn || !actualPick) return true
      return actualPick.diff(geofenceIn, 'hours', true) <= 24
    },
    geofenceInNotEqualActualPick({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const actualPick = this.parseDateValue(this.form.actualPick)

      if (!geofenceIn || !actualPick) return true
      return !geofenceIn.isSame(actualPick, 'second')
    },
    geofenceInLteActualPick({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const actualPick = this.parseDateValue(this.form.actualPick)

      if (!geofenceIn || !actualPick) return true
      return geofenceIn.isSameOrBefore(actualPick, 'second')
    },
    geofenceInNotEqualGeofenceOut({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)

      if (!geofenceIn || !geofenceOut) return true
      return !geofenceIn.isSame(geofenceOut, 'second')
    },
    geofenceInLteGeofenceOut({ value }) {
      const geofenceIn = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)

      if (!geofenceIn || !geofenceOut) return true
      return geofenceIn.isSameOrBefore(geofenceOut, 'second')
    },
    actualPickGtStartTime({ value }) {
      const actualPick = this.parseDateValue(value)
      const startTime = this.assignmentStartTime ? moment(this.assignmentStartTime) : null
      const geofenceIn = this.parseDateValue(this.form.geofenceIn)

      if (!actualPick || !startTime || geofenceIn) return true
      return actualPick.isAfter(startTime, 'second')
    },
    actualPickGtGeofenceIn({ value }) {
      const actualPick = this.parseDateValue(value)
      const geofenceIn = this.parseDateValue(this.form.geofenceIn)

      if (!actualPick || !geofenceIn) return true
      return actualPick.isAfter(geofenceIn, 'second')
    },
    actualPickLtGeofenceOut({ value }) {
      const actualPick = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)

      if (!actualPick || !geofenceOut) return true
      return actualPick.isBefore(geofenceOut, 'second')
    },
    actualPickLtGeofenceInDrop({ value }) {
      const actualPick = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)
      const geofenceInDrop = this.parseDateValue(this.geofenceInDrop)

      if (!actualPick || geofenceOut || !geofenceInDrop) return true
      return actualPick.isBefore(geofenceInDrop, 'second')
    },
    actualPickLtActualDrop({ value }) {
      const actualPick = this.parseDateValue(value)
      const geofenceOut = this.parseDateValue(this.form.geofenceOut)
      const geofenceInDrop = this.parseDateValue(this.geofenceInDrop)
      const actualDrop = this.parseDateValue(this.actualDrop)

      if (!actualPick || geofenceOut || geofenceInDrop || !actualDrop) return true
      return actualPick.isBefore(actualDrop, 'second')
    },
    geofenceOutGtActualPick({ value }) {
      const geofenceOut = this.parseDateValue(value)
      const actualPick = this.parseDateValue(this.form.actualPick)

      if (!geofenceOut || !actualPick) return true
      return geofenceOut.isAfter(actualPick, 'second')
    },
    geofenceOutLtGeofenceInDrop({ value }) {
      const geofenceOut = this.parseDateValue(value)
      const geofenceInDrop = this.parseDateValue(this.geofenceInDrop)

      if (!geofenceOut || !geofenceInDrop) return true
      return geofenceOut.isBefore(geofenceInDrop, 'second')
    },
    geofenceOutLtActualDrop({ value }) {
      const geofenceOut = this.parseDateValue(value)
      const geofenceInDrop = this.parseDateValue(this.geofenceInDrop)
      const actualDrop = this.parseDateValue(this.actualDrop)

      if (!geofenceOut || geofenceInDrop || !actualDrop) return true
      return geofenceOut.isBefore(actualDrop, 'second')
    },
  },
}
</script>

<style scoped lang="scss">
.mc-delivery-track-sidebar-edit-field {
  :deep(ul.formulate-input-errors) {
    list-style: none;
    margin: 4px 0 0;
    padding: 0;
    color: #ea4a4a;
    font-size: 12px;
    font-style: italic;
  }

  :deep(ul.formulate-input-errors li.formulate-input-error::before) {
    content: '';
    display: none;
  }

  :deep([data-is-showing-errors='true'] .mx-input),
  :deep([data-is-showing-errors='true'] .mx-datepicker input) {
    border-color: #ea4a4a !important;
  }
}
</style>
